import React from "react";

export default function TopFundManager({ data }) {
  return (
    <div className="howToInvestWrapper">
      <h3 className="heading-1-bold tableTitle">{data.heading}</h3>
      <p className="para-2 tableDesc">{data.desc}</p>
      {data.managers.map((step, id) => (
        <div className="d-f-c" key={id} style={{ marginTop: "18px" }}>
          <div>
            <div className="heading-3-bold nameHeading">
              {id + 1}. {step.name}
            </div>
            <div className="para-2 tableDesc">{step.desc}</div>
          </div>
        </div>
      ))}
      <style jsx>{`
      .howToInvestWrapper{
        margin-bottom: 24px;
        padding-bottom: 32px;
      }
      @media (max-width: 768px) {
        .howToInvestWrapper {
          padding-bottom: 0;
        }
      }
      .tableTitle{
        text-decoration:none;
        margin:50px 0 16px;
      }
      .tableDesc{
          margin-bottom:16px;
      }
      .nameHeading{
        margin-bottom:12px;
      }
      `}</style>
    </div>
  );
}
